module.exports = vendor_bcf2caaf47f6dfeca042;